import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/** Une classes Tailwind com merge inteligente (última vence em conflito). */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/** Iniciais para avatar (ex.: "Ana Martins" → "AM"). */
export function initials(name?: string | null): string {
  if (!name) return '?'
  const parts = name.trim().split(/\s+/)
  if (parts.length === 1) return parts[0]!.slice(0, 2).toUpperCase()
  return (parts[0]![0]! + parts[parts.length - 1]![0]!).toUpperCase()
}

/** slug seguro a partir de um nome. */
export function slugify(value: string): string {
  return value
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)+/g, '')
    .slice(0, 48)
}

/** Cor de texto (preto/branco) com melhor contraste sobre um hex de fundo. */
export function contrastText(hex: string): '#000000' | '#ffffff' {
  const c = hex.replace('#', '')
  if (c.length !== 6) return '#000000'
  const r = parseInt(c.slice(0, 2), 16)
  const g = parseInt(c.slice(2, 4), 16)
  const b = parseInt(c.slice(4, 6), 16)
  // luminância relativa aproximada
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255
  return luminance > 0.6 ? '#000000' : '#ffffff'
}

export function truncate(value: string, max = 80): string {
  return value.length > max ? value.slice(0, max - 1) + '…' : value
}
